/**
 * @generated SignedSource<<c242db2b95b706917bec47fb8478679e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueTypePickerIssueType$data = {
  readonly description: string | null | undefined;
  readonly id: string;
  readonly isEnabled: boolean;
  readonly name: string;
  readonly " $fragmentType": "IssueTypePickerIssueType";
};
export type IssueTypePickerIssueType$key = {
  readonly " $data"?: IssueTypePickerIssueType$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTypePickerIssueType">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "IssueTypePickerIssueType"
};

(node as any).hash = "40fbe73c45b53ba4acb5d2b67ce97e1b";

export default node;
